import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import ImageTreatmentLink from './../ImageTreatmentLink/ImageTreatmentLink';
import { createMarkup } from '../../../../utils/helpers';
import './ResponsibilityBody.css';

// @TODO: hard coded content which will need to be refactored for CMS integration
const ResponsibilityBody = ({ isDesktop, blockData }) => {
    const { title, subtitle, description, achievements_title, ctas, achievements_lines, box } = blockData;

    return (
        <section className="section responsibility-body">
            <div className="container">
                <div className="columns">
                    <div className="column is-11-tablet is-offset-1-tablet">
                        {<ScrollAnimation
                            duration={1.5}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}>
                            <div className="big-title border-left-yellow">
                                {title}
                            </div>
                        </ScrollAnimation>}
                        {<ScrollAnimation
                            duration={1.5}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}>
                            <div className='subtitle'>{subtitle}</div>
                        </ScrollAnimation>}
                        {<ScrollAnimation
                            duration={1.5}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}>
                            <div className='description' dangerouslySetInnerHTML={createMarkup(description)}></div>
                        </ScrollAnimation>}
                        {achievements_lines && <ScrollAnimation
                            duration={1.5}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}>
                            <div className='achievements-title'>{achievements_title}</div>
                        </ScrollAnimation>}
                        {achievements_lines && <div className='achievements-items'>
                            <ul>
                                {achievements_lines.map((lineText, index) =>
                                    <li key={index}>
                                        <ScrollAnimation
                                            delay={150 * (index + 1)}
                                            animateOnce={true}
                                            animateIn="fadeIn"
                                            initiallyVisible={false}
                                            offset={0}>
                                            <div className="bullet">
                                                <svg aria-hidden="true" viewBox="0 0 32 32" focusable="false"><circle stroke="none" cx="16" cy="16" r="10"></circle></svg>
                                            </div>
                                            {lineText}
                                        </ScrollAnimation>
                                    </li>
                                )}
                            </ul>
                        </div>}
                    </div>
                </div>
                {ctas && <div className="columns">
                    <div className="column is-offset-1-tablet is-10-tablet is-12-desktop">
                        <div className="cta-wrapper animated fadeInLeft">
                            {ctas.map((button, index) => {
                                if (button.linkOut === true) {
                                    return <a key={index} className={`button ${isDesktop ? 'animated fadeInRight' : ''}`} target={button.target} rel="noreferrer" href={button.url}>
                                        <span>{button.label}</span>
                                    </a>;
                                }
                                return <Link key={index} className={`button ${isDesktop ? 'animated fadeInRight' : ''}`} to={button.url}>
                                    <span>{button.label}</span>
                                </Link>;
                            })}
                        </div>
                    </div>
                </div>}
                {box && <div className="columns">
                    <div className="column is-offset-1-tablet is-11-tablet is-12-desktop is-relative">
                        <ImageTreatmentLink
                            backgroundImage={require('./images' + box.backgroundImage)}
                            backgroundPosition={box.backgroundPosition}
                            linearOverlay={true}
                            overlayOpacity='0.4'
                            orientation='left'
                            isLocalUrl={true}
                            stopColor1='#26588D'
                            stopColor2='#38C2D8'
                        />

                        {box.title && <div className='box-overlay'>
                            <div className='box-title'>{box.title}</div>
                            <div className='box-description'>{box.description}</div>
                        </div>}
                    </div>
                </div>}
            </div>

        </section>
    );
};

ResponsibilityBody.propTypes = {
    achievements_lines: PropTypes.array,
    blockData: PropTypes.object,
    isDesktop: PropTypes.bool,
};

export default ResponsibilityBody;
